import React, {memo} from 'react';
import {Button} from '@tickchak/react-share/app';
import * as css from './GeneratorSuggestions.css';
import type {GeneratorSuggestion} from '../utils/types';

export interface GeneratorSuggestionsProps {
    suggestions: GeneratorSuggestion[];
    onSuggestionClick: (text: string, index: number, displayText?: string) => void;
}

function GeneratorSuggestions({suggestions, onSuggestionClick}: GeneratorSuggestionsProps) {
    return (
        <css.suggestionsStack>
            {suggestions.map(({key, label, prompt, disabled}, index) => (
                <Button
                    customStyle={{fontWeight: 500}}
                    key={key}
                    onClick={() => onSuggestionClick(prompt ?? label, index, label)}
                    disabled={disabled}
                    data-cy={`ai-generator-suggestion-${index}`}
                    size="category"
                >
                    {label}
                </Button>
            ))}
        </css.suggestionsStack>
    );
}

export default memo(GeneratorSuggestions);
